module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('button', {
    staticClass: "back-button",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.name) + "\n          "), (_vm.preq_is_converted === '1') ? _c('b-badge', {
    attrs: {
      "variant": 'success'
    }
  }, [_vm._v("Converted")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card formCard"
  }, [_c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_vm._v("\n            Shipping Details Form\n            "), (_vm.preq_is_converted == 0) ? _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addShippers(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })]) : _vm._e()], 1)]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [(_vm.preq_is_converted === '1') ? _c('b', [_vm._v("Job No : " + _vm._s(_vm.JobNo))]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [(_vm.preq_is_converted === '1') ? _c('b', [_vm._v("Job Date : " + _vm._s(_vm.JobDate))]) : _vm._e()])])], 1), _vm._v(" "), (_vm.preq_is_converted == 0) ? _c('div', _vm._l((_vm.shippersArr), function(shipper, index) {
    return _c('b-row', {
      key: index
    }, [_c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('label', [_vm._v("Shipper Type " + _vm._s(parseInt(index) + 1))]), _vm._v(" "), _c('model-list-select', {
      style: ({
        borderColor: shipper.shipper_type_err ? 'red' : '',
      }),
      attrs: {
        "isDisabled": _vm.preq_is_converted == 1 || shipper.preq_cm_id > 0,
        "list": _vm.shipperTypeList,
        "option-value": "val",
        "option-text": "text",
        "placeholder": "Select Shipper Type"
      },
      on: {
        "input": function($event) {
          _vm.toggleShipperInput(index)
        }
      },
      model: {
        value: (shipper.shipper_type),
        callback: function($$v) {
          _vm.$set(shipper, "shipper_type", $$v)
        },
        expression: "shipper.shipper_type"
      }
    }), _vm._v(" "), (shipper.shipper_type_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(shipper.shipper_type_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('label', [_vm._v("Shipper Name " + _vm._s(parseInt(index) + 1))]), _vm._v(" "), (shipper.shipper_type === 'new') ? _c('b-form-input', {
      style: ({
        borderColor: shipper.shipper_name_err ? 'red' : '',
      }),
      attrs: {
        "disabled": _vm.preq_is_converted == 1 || shipper.preq_cm_id > 0,
        "type": "text",
        "placeholder": "Enter Shipper Name"
      },
      model: {
        value: (shipper.shipper_name),
        callback: function($$v) {
          _vm.$set(shipper, "shipper_name", $$v)
        },
        expression: "shipper.shipper_name"
      }
    }) : _vm._e(), _vm._v(" "), (shipper.shipper_type === 'existing') ? _c('model-list-select', {
      style: ({
        borderColor: shipper.shipper_name_err ? 'red' : '',
      }),
      attrs: {
        "isDisabled": _vm.preq_is_converted == 1 || shipper.preq_cm_id > 0,
        "list": _vm.$store.getters['common/getAllClientList'],
        "option-value": "clientId",
        "option-text": "clientName",
        "placeholder": "Select Shipper Name"
      },
      on: {
        "input": function($event) {
          _vm.getShpperNameId(index, shipper.fk_client_id)
        }
      },
      model: {
        value: (shipper.fk_client_id),
        callback: function($$v) {
          _vm.$set(shipper, "fk_client_id", $$v)
        },
        expression: "shipper.fk_client_id"
      }
    }) : _vm._e(), _vm._v(" "), (shipper.shipper_name_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(shipper.shipper_name_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('label', [_vm._v("Contact Person Name " + _vm._s(parseInt(index) + 1))]), _vm._v(" "), _c('b-form-input', {
      style: ({
        borderColor: shipper.contact_person_name_err ? 'red' : '',
      }),
      attrs: {
        "disabled": _vm.preq_is_converted == 1 || shipper.preq_cm_id > 0,
        "type": "text",
        "placeholder": "Enter Contact Person Name"
      },
      model: {
        value: (shipper.contact_person_name),
        callback: function($$v) {
          _vm.$set(shipper, "contact_person_name", $$v)
        },
        expression: "shipper.contact_person_name"
      }
    }), _vm._v(" "), (shipper.contact_person_name_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(shipper.contact_person_name_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('label', [_vm._v("Contact Email " + _vm._s(parseInt(index) + 1))]), _vm._v(" "), _c('b-form-input', {
      style: ({
        borderColor: shipper.contact_email_err ? 'red' : '',
      }),
      attrs: {
        "disabled": _vm.preq_is_converted == 1 || shipper.preq_cm_id > 0,
        "type": "email",
        "placeholder": "Enter Contact Email"
      },
      model: {
        value: (shipper.contact_email),
        callback: function($$v) {
          _vm.$set(shipper, "contact_email", $$v)
        },
        expression: "shipper.contact_email"
      }
    }), _vm._v(" "), (shipper.contact_email_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(shipper.contact_email_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('label', [_vm._v("Contact Mobile " + _vm._s(parseInt(index) + 1))]), _vm._v(" "), _c('b-form-input', {
      style: ({
        borderColor: shipper.contact_mobile_err ? 'red' : '',
      }),
      attrs: {
        "disabled": _vm.preq_is_converted == 1 || shipper.preq_cm_id > 0,
        "type": "number",
        "placeholder": "Enter Contact Mobile"
      },
      model: {
        value: (shipper.contact_mobile),
        callback: function($$v) {
          _vm.$set(shipper, "contact_mobile", $$v)
        },
        expression: "shipper.contact_mobile"
      }
    }), _vm._v(" "), (shipper.contact_mobile_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(shipper.contact_mobile_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('label', [_vm._v("Expected Volume " + _vm._s(parseInt(index) + 1))]), _vm._v(" "), _c('b-form-input', {
      style: ({
        borderColor: shipper.expected_volume_err ? 'red' : '',
      }),
      attrs: {
        "disabled": _vm.preq_is_converted == 1,
        "type": "text",
        "placeholder": "Enter Expected Volume"
      },
      model: {
        value: (shipper.expected_volume),
        callback: function($$v) {
          _vm.$set(shipper, "expected_volume", $$v)
        },
        expression: "shipper.expected_volume"
      }
    }), _vm._v(" "), (shipper.expected_volume_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(shipper.expected_volume_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('label', [_vm._v("Cargo Readiness Estimated Date " + _vm._s(parseInt(index) + 1))]), _vm._v(" "), _c('b-form-input', {
      style: ({
        borderColor: shipper.cargo_estimated_readiness_date_err ? 'red' : '',
      }),
      attrs: {
        "disabled": _vm.preq_is_converted == 1,
        "type": "date",
        "placeholder": "Select Date"
      },
      model: {
        value: (shipper.cargo_estimated_readiness_date),
        callback: function($$v) {
          _vm.$set(shipper, "cargo_estimated_readiness_date", $$v)
        },
        expression: "shipper.cargo_estimated_readiness_date"
      }
    }), _vm._v(" "), (shipper.cargo_estimated_readiness_date_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(shipper.cargo_estimated_readiness_date_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('label', [_vm._v("Estimated Date of Arrival at Port " + _vm._s(parseInt(index) + 1))]), _vm._v(" "), _c('b-form-input', {
      style: ({
        borderColor: shipper.estimated_arrival_at_port_date_err ? 'red' : '',
      }),
      attrs: {
        "disabled": _vm.preq_is_converted == 1,
        "type": "date",
        "placeholder": "Select Date"
      },
      model: {
        value: (shipper.estimated_arrival_at_port_date),
        callback: function($$v) {
          _vm.$set(shipper, "estimated_arrival_at_port_date", $$v)
        },
        expression: "shipper.estimated_arrival_at_port_date"
      }
    }), _vm._v(" "), (shipper.estimated_arrival_at_port_date_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(shipper.estimated_arrival_at_port_date_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('label', [_vm._v("Cargo Arrival at Port " + _vm._s(parseInt(index) + 1) + " ")]), _vm._v(" "), _c('b-form-input', {
      style: ({
        borderColor: shipper.cargo_arrival_at_port_err ? 'red' : '',
      }),
      attrs: {
        "disabled": _vm.preq_is_converted == 1,
        "type": "date",
        "placeholder": "Select Date"
      },
      model: {
        value: (shipper.cargo_arrival_at_port),
        callback: function($$v) {
          _vm.$set(shipper, "cargo_arrival_at_port", $$v)
        },
        expression: "shipper.cargo_arrival_at_port"
      }
    }), (shipper.cargo_arrival_at_port_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(shipper.cargo_arrival_at_port_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('label', [_vm._v("Remark " + _vm._s(parseInt(index) + 1))]), _vm._v(" "), _c('b-textarea', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "disabled": _vm.preq_is_converted == 1,
        "placeholder": "Enter Remarks",
        "rows": "3"
      },
      model: {
        value: (shipper.remarks),
        callback: function($$v) {
          _vm.$set(shipper, "remarks", $$v)
        },
        expression: "shipper.remarks"
      }
    })], 1), _vm._v(" "), (
      shipper.preq_cm_id > 0 &&
      shipper.preq_cm_is_active == 1 &&
      shipper.isKYC == 'No'
    ) ? _c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('label', [_vm._v("Client Status " + _vm._s(parseInt(index) + 1))]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "disabled": _vm.preq_is_converted == 1,
        "list": _vm.clientStatusList,
        "option-value": "val",
        "option-text": "text",
        "placeholder": "Select Client Status"
      },
      on: {
        "input": function($event) {
          _vm.activateClient(shipper)
        }
      },
      model: {
        value: (shipper.preq_cm_is_active),
        callback: function($$v) {
          _vm.$set(shipper, "preq_cm_is_active", $$v)
        },
        expression: "shipper.preq_cm_is_active"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "1"
      }
    }, [_c('label', [_vm._v("Action")]), _vm._v(" "), (shipper.preq_cm_id <= 0) ? _c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeShippers(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), _c('h6', [(shipper.PrerequisiteClientStatus === 'New') ? _c('b-badge', {
      attrs: {
        "variant": 'success'
      }
    }, [_vm._v(_vm._s(shipper.PrerequisiteClientStatus))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr')], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.preq_is_converted == 1 && _vm.preq_id > 0) ? _c('div', {
    staticClass: "shipper-table"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("Shipper Type")]), _vm._v(" "), _c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("Shipper Name")]), _vm._v(" "), _c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("Contact Person Name")]), _vm._v(" "), _c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("Contact Email")]), _vm._v(" "), _c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("Contact Mobile")]), _vm._v(" "), _c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("Expected Volume")]), _vm._v(" "), _c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("Cargo Readiness Estimated Date")]), _vm._v(" "), _c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("Estimated Date of Arrival at Port")]), _vm._v(" "), _c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("Cargo Arrival at Port")]), _vm._v(" "), _c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("Remark")]), _vm._v(" "), _c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shippersArr), function(shipper, index) {
    return _c('tr', {
      key: index,
      staticClass: "fade-in"
    }, [_c('td', [_vm._v(_vm._s(parseInt(index) + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipper.shipper_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipper.shipper_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipper.contact_person_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipper.contact_email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipper.contact_mobile))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipper.expected_volume))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipper.cargo_estimated_readiness_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipper.estimated_arrival_at_port_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipper.cargo_arrival_at_port))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipper.remarks))]), _vm._v(" "), _c('td', [_c('h6', [_c('b-badge', {
      attrs: {
        "variant": 'success'
      }
    }, [_vm._v(_vm._s(shipper.PrerequisiteClientStatus))])], 1), _vm._v(" "), _c('h6', [_c('b-badge', {
      attrs: {
        "variant": shipper.PrerequisiteMapStatus === 'Active' ?
          'success' :
          'danger'
      }
    }, [_vm._v(_vm._s(shipper.PrerequisiteMapStatus))])], 1)])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.getAlLogList.length > 0) ? _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getAlLogList,
      "fields": _vm.fields,
      "responsive": "",
      "primary-key": "log_id"
    },
    scopedSlots: _vm._u([{
      key: "log_id",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                " + _vm._s(row0.index + 1) + "\n              ")])]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.preq_is_converted == 0) ? _c('div', {
    staticClass: "form-row centered-buttons"
  }, [_c('div', {
    staticClass: "form-col"
  }, [_c('center', [(_vm.shippersArr.length > 0) ? _c('button', {
    staticClass: "save-button",
    on: {
      "click": _vm.saveShippingDetails
    }
  }, [_vm._v("\n                Save\n              ")]) : _vm._e(), _vm._v(" "), (_vm.preq_id > 0 && _vm.preq_is_converted == 0) ? _c('button', {
    staticClass: "save-button",
    on: {
      "click": _vm.convertConsolidationAss
    }
  }, [_vm._v("\n                Convert Consolidation\n              ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "back-button ml-2",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Back")])])], 1)]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.alert.content) ? _c('div', {
    staticClass: "alert-dialog"
  }, [_c('div', {
    staticClass: "alert-content"
  }, [_c('p', [_vm._v(_vm._s(_vm.alert.content))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.closeAlert
    }
  }, [_vm._v(_vm._s(_vm.alert.ok))])])]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "alert-dialog"
  }, [_c('div', {
    staticClass: "alert-content"
  }, [_c('p', [_vm._v("\n        There are " + _vm._s(_vm.kycPendingCount) + " KYC pending and " + _vm._s(_vm.kycCompletedCount) + " KYC\n        completed entries. Do you want to proceed?\n      ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("Numbers of Container"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.capitalizeAll,
      "id": "no_of_container",
      "name": "no_of_container"
    },
    on: {
      "input": _vm.validateInput
    },
    model: {
      value: (_vm.no_of_container),
      callback: function($$v) {
        _vm.no_of_container = $$v
      },
      expression: "no_of_container"
    }
  })], 1)], 1), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.no_of_container <= 0 ? true : false
    },
    on: {
      "click": _vm.proceed
    }
  }, [_vm._v("Proceed")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ff6f6d8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Prerequisite/addPrerequisite.vue
// module id = 2553
// module chunks = 0